import { LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";

import ROSTER_PROVIDERS from "@/constants/ROSTER_PROVIDERS";
import DirectoryTable from "@/directory/DirectoryTable";
import { Cell, CellLinkListMore } from "@/directory/DirectoryTable/Cells";
import useUserSchoolGet from "@/users/useUserSchoolGet";

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const PAGE_SIZE = 10;

const PAYLOAD = {
  include_district: true,
  include_licenses: true,
  sort: "name",
};

const SchoolTable = ({ user }) => {
  const { data: schools, loading: isLoading } = useUserSchoolGet(
    user.id,
    PAYLOAD,
  );

  const columns = [
    {
      accessor: "name",
      Header: "School name",
      Cell: (cell) => <Cell cell={cell} />,
    },
    {
      accessor: "district",
      Header: "Parent district",
      disableSortBy: true,
      Cell: (cell) => (
        <CellLinkListMore value={cell.value.map((district) => district.name)} />
      ),
    },
    {
      accessor: "licenses",
      Header: "Subscriptions",
      disableSortBy: true,
      Cell: (cell) => (
        <CellLinkListMore
          value={cell.value?.map((license) => license.product)}
        />
      ),
    },
    {
      accessor: "sources",
      Header: "Data source",
      disableSortBy: true,
      Cell: (cell) =>
        cell.value.length >= 1 ? (
          <CellLinkListMore
            value={cell.value.map(
              ({ provider }) =>
                ROSTER_PROVIDERS[provider]?.displayName || provider,
            )}
          />
        ) : (
          <Cell cell={{ ...cell, value: "Newsela" }} />
        ),
    },
  ];

  const notFoundMessage = (
    <DirectoryTable.NotFound subTitle="There are no schools associated with this user" />
  );

  if (isLoading) return <LoadingSpinner />;

  return (
    <DirectoryTable
      title=""
      data={schools}
      pageSize={PAGE_SIZE}
      totalCount={schools.length}
      useManualUpdate={false}
      columns={columns}
      notFoundMessage={notFoundMessage}
    />
  );
};

SchoolTable.propTypes = propTypes;

export default SchoolTable;
